import { z } from 'zod'
import { eventSchema } from './event-vocabulary.js'
import { conditionSchema } from './condition.js'

export const ruleScopeNames = ['self', 'descendants'] as const
export type RuleScope = (typeof ruleScopeNames)[number]

export const ruleActionSchema = z.object({
  commandId: z.string().describe('A registered AgentCommandSpec id'),
  args: z.record(z.string(), z.unknown()).default({}),
})
export type RuleAction = z.infer<typeof ruleActionSchema>

export const ruleSchema = z.object({
  id: z.string(),
  name: z.string().describe('Human label for the rule').optional(),
  enabled: z.boolean().default(true),
  event: eventSchema,
  scope: z.enum(ruleScopeNames).describe('Watch the entity itself or things inside it').default('self'),
  conditions: z.array(conditionSchema).default([]),
  actions: z.array(ruleActionSchema).min(1),
  pausedReason: z.enum(['loop-guard']).describe('Set when the engine auto-pauses the rule').optional(),
})
export type Rule = z.infer<typeof ruleSchema>

export const automationConfigSchema = z.object({
  rules: z.array(ruleSchema).default([]),
})
export type AutomationConfig = z.infer<typeof automationConfigSchema>
